import EventEmitter from 'eventemitter3';
import React, { useEffect, useState } from 'react';
import { NetworkErrorPage } from '../pages/NetworkErrorPage';

const NETWORK_ERROR_EVENT = 'network-error';
const NETWORK_SUCCESS_EVENT = 'network-success';

const networkErrorEmitter = new EventEmitter();

export const emitNetworkError = () => {
  networkErrorEmitter.emit(NETWORK_ERROR_EVENT);
};

export const emitNetworkSuccess = () => {
  networkErrorEmitter.emit(NETWORK_SUCCESS_EVENT);
};

interface NetworkErrorProviderProps {
  children: React.ReactNode;
  maxErrorsBeforeRedirect?: number;
}

export const NetworkErrorGate: React.FC<NetworkErrorProviderProps> = ({
  children,
  maxErrorsBeforeRedirect = 1,
}) => {
  const [consecutiveNetworkErrors, setConsecutiveNetworkErrors] = useState(0);
  const shouldShowErrorPage =
    consecutiveNetworkErrors >= maxErrorsBeforeRedirect;

  useEffect(() => {
    const handleNetworkError = () => {
      setConsecutiveNetworkErrors((prev) => prev + 1);
    };

    const handleNetworkSuccess = () => {
      setConsecutiveNetworkErrors(0);
    };

    networkErrorEmitter.on(NETWORK_ERROR_EVENT, handleNetworkError);
    networkErrorEmitter.on(NETWORK_SUCCESS_EVENT, handleNetworkSuccess);

    return () => {
      networkErrorEmitter.off(NETWORK_ERROR_EVENT, handleNetworkError);
      networkErrorEmitter.off(NETWORK_SUCCESS_EVENT, handleNetworkSuccess);
    };
  }, []);

  const resetErrorCount = () => {
    setConsecutiveNetworkErrors(0);
  };

  return shouldShowErrorPage ? (
    <NetworkErrorPage resetErrorCount={resetErrorCount} />
  ) : (
    children
  );
};
